<template>
    <list-page title="应用管理" :api="searchUrl" :searchParam="searchParam" :showPager="true" ref="application">
        <template v-slot:search>
            <div class="block">
                <el-input size="mini" v-model="searchParam.Key"></el-input>
            </div>
        </template>
        <template v-slot:new>
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="visible = true"> 新增 </el-button>
        </template>
        <template #other>
            <InterfaceAuth v-if="interfaceVisible" v-model:visible="interfaceVisible" :app="currentApp" @refresh="getData"></InterfaceAuth>
            <EditApp v-if="visible" v-model:visible="visible" @refresh="getData"></EditApp>
        </template>
        <el-table-column type="index" width="80px" label="序号"></el-table-column>
        <el-table-column prop="AppName" label="应用名称"></el-table-column>
        <el-table-column prop="TenantName" label="租户"></el-table-column>
        <el-table-column prop="AppAK" label="应用标识(AK)"></el-table-column>
        <el-table-column prop="AppSK" label="应用密钥(SK)"></el-table-column>
        <el-table-column prop="MinInterval" label="接口最小调用间隔（秒）"></el-table-column>
        <el-table-column label="操作" width="230px">
            <template #default="{ row }">
                <el-button type="primary" @click="showInterface(row)" size="mini" icon="el-icon-setting">接口授权</el-button>
                <el-button type="danger" @click="removeRow(row)" size="mini" icon="el-icon-delete">删除</el-button>
            </template>
        </el-table-column>
    </list-page>
</template>
<script>
import InterfaceAuth from "./components/InterfaceAuth";
import EditApp from "./components/EditApp";

export default {
    name: "App",
    components: {
        InterfaceAuth,
        EditApp,
    },
    data() {
        return {
            searchParam: {
                Key: "",
            },
            searchUrl: "/Platform/GetApps",
            visible: false,
            interfaceVisible: false,
            currentApp: null,
        };
    },
    methods: {
        getData() {
            this.$refs.application.searchData();
        },
        showInterface(row) {
            this.currentApp = row;
            this.interfaceVisible = true;
        },
        removeRow(row) {
            this.$myConfirm().then(() => {
                this.$ajax.post("/Platform/RemoveApp?ak=" + row.AppAK).then((res) => {
                    this.$success("操作成功");
                    this.getData();
                });
            });
        },
    },
};
</script>
